export { Mobile } from './mobile.component';
